module.exports = function() {
  return new Worker(__webpack_public_path__ + "b88485af492ec22657ae.worker.js");
};